// @flow
import SampleImage from '@components/productDetail/images/captions/SampleImage';
import SampleImageWithLink from '@components/productDetail/images/captions/SampleImageWithLink';
import InARing from '@components/productDetail/images/captions/InARing';

import Length from '@components/productDetail/images/captions/Length';
import Width from '@components/productDetail/images/captions/Width';
import Depth from '@components/productDetail/images/captions/Depth';
import Table from '@components/productDetail/images/captions/Table';
import LWRatio from '@components/productDetail/images/captions/LWRatio';
import Culet from '@components/productDetail/images/captions/Culet';
import Girdle from '@components/productDetail/images/captions/Girdle';

const hoverCaptions: { [string]: React.ElementType } = {
  length: Length,
  width: Width,
  depth: Depth,
  lw_ratio: LWRatio,
  depth_percent: Depth,
  table_percent: Table,
  culet: Culet,
  girdle: Girdle
};

const standardCaption = ({ captionType, onToggleBandClick, bandColor, linkUrl }) => {
  return captionType === 'enlarged' ? (
    linkUrl ? <SampleImageWithLink url={linkUrl} /> : <SampleImage />
  ) : (
    <InARing onToggleBandClick={onToggleBandClick} color={bandColor} />
  );
};

const hoverCaption = ({ hoveredSpec }) => {
  if (!hoveredSpec) return;

  const HC = hoverCaptions[hoveredSpec];
  return HC && <HC />;
};

type PropsType = {
  captionType?: string,
  onToggleBandClick?: () => void,
  bandColor?: string,
  hoveredSpec: string | null
};

export default (props: PropsType) => {
  return hoverCaption(props) || standardCaption(props);
};
